import React, { useCallback, useContext, useEffect, useState } from 'react';

import AbsencesCanceledModal from '@/features/absences/components/modals/AbsencesCanceledModal';
import AbsencesCancelFormModal from '@/features/absences/components/modals/AbsencesCancelFormModal';
import AbsencesCancelModal from '@/features/absences/components/modals/AbsencesCancelModal';
import AbsencesCreatedModal from '@/features/absences/components/modals/AbsencesCreatedModal';
import AbsencesEditedModal from '@/features/absences/components/modals/AbsencesEditedModal';
import AbsencesTimeExceededModal from '@/features/absences/components/modals/AbsencesTimeExceededModal';
import AppDownloadPopupModal from '@/features/mypage/components/modals/AppDownloadPopupModal';
import ProfileEditPasswordConfirmModal from '@/features/mypage/components/modals/ProfileEditPasswordConfirmModal';
import UnlinkOtherParentConfirmModal from '@/features/mypage/components/modals/UnlinkOtherParentConfirmModal';
import UnlinkSelfConfirmModal from '@/features/mypage/components/modals/UnlinkSelfConfirmModal';
import WithdrawalConfirmationModal from '@/features/withdrawal/components/modals/WithdrawalConfirmationModal';
import { AppContext } from '@/providers/ContextProvider';

const modalComponents = {
  ProfileEditPasswordConfirmModal,
  WithdrawalConfirmationModal,
  AbsencesCancelFormModal,
  AbsencesCancelModal,
  AbsencesCreatedModal,
  AbsencesEditedModal,
  AbsencesCanceledModal,
  AbsencesTimeExceededModal,
  UnlinkOtherParentConfirmModal,
  UnlinkSelfConfirmModal,
  AppDownloadPopupModal,
};

export type ModalComponentsType = typeof modalComponents;

const ANIMATION_DURATION = 250;

const ModalRoot: React.FC = () => {
  const [renderModal, setRenderModal] = useState(true);

  const { isModalOpen, modalType, modalProps, setIsModalOpen } =
    useContext(AppContext);
  const toggle = useCallback(() => setIsModalOpen(false), [setIsModalOpen]);

  useEffect(() => {
    // render null after closing animation to reset the state inside modal
    if (isModalOpen) {
      setRenderModal(isModalOpen);
    } else {
      const timer = setTimeout(
        () => setRenderModal(isModalOpen),
        ANIMATION_DURATION,
      );
      return () => clearTimeout(timer);
    }
  }, [setRenderModal, isModalOpen]);

  if (!modalType || !renderModal) {
    return null;
  }

  const Modal = modalComponents[modalType as keyof typeof modalComponents];

  return <Modal {...modalProps} isOpen={isModalOpen} toggle={toggle} />;
};

export default ModalRoot;
